import React, { useEffect, useMemo, useState, useRef } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import CustomPagination from "../CustomWidgets/CustomPagination";
import { Empty, Input, InputNumber, Modal } from "antd";
import Edit from "../../assets/Edit.svg";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import ProductModal from "../../modals/showproductmodal";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import dummy_image from "../../assets/Images/gallery.svg";
import { useNavigate } from "react-router-dom";
import { checkPermission } from "../../Utils/permissionHelper";
import { useSelector } from "react-redux";
import JsBarcode from "jsbarcode";
import labelSample from "../../assets/35mm.png";
import labelSample2 from "../../assets/35mmx12mm.png";
import { getProductGroups } from "../../API  Functions/productGroupFunctions";
import { MultiSelectBox } from "../CustomWidgets/SelectBox";

const InventoryTableComponent = ({
  additionalData,
  isShowCostPrice,
  costingMethod,
  setAdditionalData,
  callafterUpdate,
  pagination,
  passordModal,
  allGroups,
  
}) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const [editRows, setEditRows] = useState(new Set());
  const [editValues, setEditValues] = useState({});
  const [editPriceClicked, setEditPriceClicked] = useState(false);
  const [indexarray, setindexarray] = useState([]);
  const [showpopup, setshowpopup] = useState(false);
  const [showpopupdata, setshowpopupdata] = useState([]);
  const costPriceInputRefs = useRef({});
  const sellPriceInputRefs = useRef({});
  const qtyInputRefs = useRef({});
  const timeoutRef = useRef(null);
  const focusedInputRef = useRef(null);
  const [tempEditValues, setTempEditValues] = useState({});
  const [isSalePriceValid, setIsSalePriceValid] = useState({});
  const [isImageModalVisible, setIsImageModalVisible] = useState(false);
  const [currentImageUrl, setCurrentImageUrl] = useState("");
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);
  const userData = useSelector((state) => state?.login?.user?.result);
  const [showPriceModal, setShowPriceModal] = useState(false);
  // NEW: label size state — "35x24" (existing) or "35x12" (new two-up barcode-only)
  const [labelSize, setLabelSize] = useState("35x24");
  const [selectedProducts, setSelectedProducts] = useState([]);

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store
  );
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const data = useMemo(
    () =>
      additionalData?.status
        ? additionalData?.all_product
        : additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (passordModal == false) {
      setEditValues({});
    }
  }, [passordModal]);

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);

  useEffect(() => {
    handleEditCancel();
  }, [additionalData]);

  const BarcodeCell = ({ row }) => {
    const navigate = useNavigate();
    const productId = row?.original?.quant_id;

    return (
      <div
        className="flex justify-start text-start cursor-pointer w-[90px]"
        onClick={() => navigate(`/productdetails?Id=${productId}`)}
      >
        <span>{row.original.barcode}</span>
      </div>
    );
  };

  const NameCell = ({ row }) => {
    const navigate = useNavigate();
    const productId = row?.original?.quant_id;

    return (
      <div
        className="flex text-start ms-10 cursor-pointer w-[250px]"
        onClick={() => navigate(`/productdetails?Id=${productId}`)}
      >
        <span>{row.original.product_name}</span>
      </div>
    );
  };

  const toggleSelectProduct = (item) => {
    setSelectedProducts((prev) => {
      const exists = prev.find((p) => p.id === item.quant_id);

      if (exists) {
        return prev.filter((p) => p.id !== item.quant_id);
      }

      return [
        ...prev,
        {
          id: item.quant_id,
          name: item.product_name || item.name,
          barcode: item.barcode,
          price: item.current_price || item.sale_price,
        },
      ];
    });
  };

  const handleSelectAll = (checked, page) => {
    if (checked) {
      setSelectedProducts((prev) => {
        const newItems = page
          .map((row) => row.original)
          .filter((item) => !prev.some((p) => p.id === item.quant_id))
          .map((item) => ({
            id: item.quant_id,
            name: item.product_name || item.name,
            barcode: item.barcode,
            price: item.current_price || item.sale_price,
          }));

        return [...prev, ...newItems];
      });
    } else {
      setSelectedProducts((prev) =>
        prev.filter((p) => !page.some((row) => row.original.quant_id === p.id))
      );
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "selection",
        disableSortBy: true,
        Header: () => (
          <input
            type="checkbox"
            checked={page.every((row) =>
              selectedProducts.some((p) => p.id === row.original.quant_id)
            )}
            onChange={(e) => handleSelectAll(e.target.checked, page)}
          />
        ),
        Cell: ({ row }) => (
          <input
            type="checkbox"
            checked={selectedProducts.some(
              (p) => p.id === row.original.quant_id
            )}
            onChange={() => toggleSelectProduct(row.original)}
          />
        ),
        width: 30,
      },

      {
        Header: t(""),
        disableSortBy: true,
        accessor: "product_image_url",
        headerClassName: "text-center",
        width: 40,
        Cell: ({ row }) => (
          <div className="flex h-50 items-center justify-center">
            <img
              src={dummy_image}
              alt="Dummy"
              style={{
                maxHeight: 30,
                maxWidth: 30,
                minHeight: 30,
                minWidth: 30,
                objectFit: "contain",
                cursor: "pointer",
              }}
              onClick={() => {
                setCurrentImageUrl(
                  row.original.image_url || row.original.image
                );
                setIsImageModalVisible(true);
              }}
            />
          </div>
        ),
      },
      {
        Header: ({ column }) => (
          <div
            style={{ maxWidth: "80px" }}
            className="text-start" title={t("Barcode")}>
            {t("Barcode")}
          </div>
        ),
        accessor: "barcode",
        headerClassName: "text-start",
        width: 70,
        Cell: BarcodeCell,
      },
      {
        Header: (
          <div className="text-center text-balance" title={t("Product Name")}>
            {t("Product Name")}
          </div>
        ),
        accessor: "product_name",
        headerClassName: "text-start",
        width: 200,
        Cell: NameCell,
      },

      ...(!userData?.is_warehouse
        ? [
            {
              Header: (
                <div
                  className="text-center text-balance"
                  title={t("Product Groups")}
                  style={{ maxWidth: "130px" }}
                >
                  {t("Product Groups")}
                </div>
              ),
              accessor: "group_list",
              headerClassName: "text-center",
              Cell: ({ row }) => {
                const rowIndex = row.index;

                const selectedGroupIds =
                  tempEditValues[rowIndex]?.group_ids ??
                  row.original.group_list?.map((g) => g.id) ??
                  [];
                const selectedOptions = allGroups
                  ?.filter((g) => selectedGroupIds.includes(g.id))
                  .map((g) => ({
                    value: g.id,
                    label: i18n.language === "ar" ? g.name_ar : g.name,
                  }));

                if (!editRows.has(rowIndex)) {
                  const groupNames = row.original.group_list
                    ?.map((g) =>
                      i18n.language === "ar" ? g.name_ar ?? g.name : g.name
                    )
                    .join(", ");

                  const displayNames =
                    groupNames?.length > 50
                      ? `${groupNames?.slice(0, 50)}...`
                      : groupNames;

                  return (
                    <div className="flex justify-center text-center w-[120px]">
                      <span title={displayNames}>{displayNames || "-"}</span>
                    </div>
                  );
                }

                return (
                  <div className="flex justify-center w-[140px] -mt-2">
                    <MultiSelectBox
                      name="group_ids"
                      defaultValue={selectedOptions}
                      placeholder={t("Select Groups")}
                      options={allGroups?.map((item) => ({
                        value: item.id,
                        label:
                          i18n.language === "ar"
                            ? item.name_ar
                            : item.name,
                      }))}
                      onChange={(event) => {
                        handleInputChange(
                          rowIndex,
                          "group_ids",
                          event.target.value
                        );
                      }}
                    />
                  </div>
                );
              },
            },
          ]
        : []),

      {
        Header: (
          <div
            className="text-center text-balance "
            title={t("Secondary Barcode")}
            style={{ maxWidth: "120px" }}
          >
            {t("Secondary Barcode")}
          </div>
        ),
        accessor: "secondary_barcode",
        headerClassName: "text-start",
        width: 140,
        Cell: ({ row }) => {
          const secondBarcode =
            editValues[row.index]?.secondary_barcode ??
            row.values.secondary_barcode;
          const uom = row.original.uom;
          
          if (editRows?.has(row.index)) {
            return (
              <div className="flex justify-center">
                <InputNumber
                  className="w-40"
                  controls={false}
                  placeholder={secondBarcode}
                  value={tempEditValues[row.index]?.secondary_barcode}
                  onChange={(value) => {
                    if (value === "" || (value >= 0)) {
                      handleInputChange(row.index, "secondary_barcode", value);
                    }
                  }}
                  maxLength={14}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onFocus={(e) => e.target.select()}
                />
              </div>
            );
          }
          return (
            <div className="flex justify-center">
              {secondBarcode === false ? "" : `${secondBarcode}`}
            </div>
          );
        },
      },
      {
        Header: (
          <div
            className="text-center text-balance  "
            title={t("Product Short Code")}
            style={{ maxWidth: "110px" }}
          >
            {t("Product Short Code")}
          </div>
        ),
        accessor: "product_shortcut",
        headerClassName: " text-center",
        width: 80,
        Cell: ({ row }) => {
          const customName =
            editValues[row.index]?.product_shortcut ??
            row.values.product_shortcut ??
            "";

          return editRows.has(row.index) && !userData?.is_sub_store ? (
            <div className="flex justify-center w-full">
              <Input
                type="text"
                className="w-28"
                placeholder={customName}
                value={tempEditValues[row.index]?.product_shortcut}
                onChange={(e) => {
                  handleInputChange(
                    row.index,
                    "product_shortcut",
                    e.target.value
                  );
                }}
                maxLength={10}
                onFocus={() => handleInputFocus(row.index, "product_shortcut")}
                readOnly={userData?.is_sub_store}
                onKeyPress={(e) => {
                  if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          ) : (
            <div className="flex justify-center text-center w-[100px]">
              <span>{customName}</span>
            </div>
          );
        },
      },

      {
        Header: (
          <div
            className="text-center text-balance "
            title={t("Weighing Scale Product Code")}
            style={{ maxWidth: "120px" }}
          >
            {t("Weighing Scale Product Code")}
          </div>
        ),
        accessor: "machine_barcode",
        headerClassName: "text-start",
        width: 140,
        Cell: ({ row }) => {
          const machineBarcode =
            editValues[row.index]?.machine_barcode ??
            row.values.machine_barcode;
          const uom = row.original.uom;
          if (
            editRows?.has(row.index) &&
            (uom === "KG" ||
              uom === "كجم" ||
              uom == "Liter" ||
              uom == "لتر" ||
              uom == "Meter")
          ) {
            return (
              <div className="flex justify-center">
                <InputNumber
                  className="w-20"
                  controls={false}
                  placeholder={machineBarcode}
                  value={tempEditValues[row.index]?.machine_barcode}
                  onChange={(value) => {
                    if (value === "" || (value >= 0 && value <= 9999999)) {
                      handleInputChange(row.index, "machine_barcode", value);
                    }
                  }}
                  maxLength={7}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onFocus={(e) => e.target.select()}
                />
              </div>
            );
          }
          return (
            <div className="flex justify-center">
              {machineBarcode === false ? "" : `${machineBarcode}`}
            </div>
          );
        },
      },

      ...(!allStores && isShowCostPrice === true
        ? [
            {
              Header: (
                <div
                  className="text-center text-balance"
                  title={t("Cost Price")}
                  style={{ maxWidth: "100px" }}
                >
                  {t("Cost Price")}
                </div>
              ),
              accessor: "current_cost_price",
              headerClassName: "text-center ms-2",
              width: 80,
              Cell: ({ row }) => (
                <div className="flex justify-center">
                  {editRows?.has(row.index) ? (
                    <Input
                      type="number"
                      className="w-16"
                      placeholder={row.values.current_cost_price}
                      ref={(element) =>
                        (costPriceInputRefs.current[row.index] = element)
                      }
                      value={tempEditValues[row.index]?.current_cost_price}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          value === "" ||
                          (/^[0-9]*\.?[0-9]{0,2}$/.test(value) &&
                            value.length <= 5)
                        ) {
                          handleInputChange(
                            row.index,
                            "current_cost_price",
                            value
                          );
                        }
                      }}
                      maxLength={5}
                      onFocus={() =>
                        handleInputFocus(row.index, "current_cost_price")
                      }
                      onKeyPress={(e) => {
                        const value = e.target.value;
                        if (
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key === "." &&
                          value.includes(".")
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  ) : (
                    `EGP ${(
                      editValues[row.index]?.current_cost_price ??
                      row.values.current_cost_price
                    )?.toFixed(2)}`
                  )}
                </div>
              ),
            },
          ]
        : []),

      ...(!allStores
        ? [
            {
              Header: (
                <div
                  className="text-center text-balance"
                  title={t("sale_price")}
                  style={{ maxWidth: "100px" }}
                >
                  {t("Sale Price")}
                </div>
              ),
              accessor: "current_price",
              width: 80,
              Cell: ({ row }) => (
                <div className="flex justify-center">
                  {editRows?.has(row.index) ? (
                    <Input
                      type="number"
                      className={`w-16 ${
                        isSalePriceValid[row.index] === false
                          ? "border-red"
                          : ""
                      }`}
                      placeholder={row.values.current_price}
                      ref={sellPriceInputRefs.current[row.index]}
                      value={tempEditValues[row.index]?.current_price}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (
                          value === "" ||
                          (/^\d*\.?\d{0,2}$/.test(value) && value.length <= 5)
                        ) {
                          handleInputChange(row.index, "current_price", value);
                        }
                      }}
                      maxLength={5}
                      onFocus={() =>
                        handleInputFocus(row.index, "current_price")
                      }
                      onKeyPress={(e) => {
                        const value = e.target.value;
                        if (
                          !/[0-9]/.test(e.key) &&
                          e.key !== "Backspace" &&
                          e.key === "." &&
                          (value === "" || value.includes("."))
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  ) : (
                    `EGP ${(
                      editValues[row.index]?.current_price ??
                      row.values.current_price
                    )?.toFixed(2)}`
                  )}
                </div>
              ),
            },
          ]
        : []),

      ...(allStores
        ? [
            {
              Header: (
                <div
                  className="text-center text-balance"
                  title={t("Store Wise Quantity")}
                  style={{ maxWidth: "180px" }}
                >
                  {t("Store Wise Quantity")}
                </div>
              ),
              accessor: "store_wise_quantity",
              headerClassName: "text-center",
              width: 200,
              Cell: ({ row }) => {
                const storeData = row.original.store_wise_quantity || [];

                return (
                  <div className="px-2">
                    <div className="flex flex-col text-left leading-5">
                      {storeData.map((item, index) => (
                        <span key={index}>
                          {item.store_name} <span className="font-semibold">({Number(item.qty || 0)})</span>
                        </span>
                      ))}
                    </div>
                  </div>
                );
              },
            },
          ]
        : []),

      {
        Header: (
          <div
            className="text-center "
            title={t("Quantity")}
            style={{ maxWidth: "100px" }}
          >
            {t("Quantity")}
          </div>
        ),
        accessor: "system_quantity",
        width: 80,
        Cell: ({ row }) => {
          const uom = row.original.uom;
          return (
            <div className="flex justify-center">
              {editRows?.has(row.index) ? (
                <Input
                  type="text"
                  className="w-16"
                  placeholder={row.values.system_quantity}
                  ref={(element) => {
                    qtyInputRefs.current[row.index] = element;
                    focusedInputRef.current = element;
                  }}
                  min={0}
                  value={tempEditValues[row.index]?.system_quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (uom !== "Units" &&
                        /^\d*\.?\d{0,3}$/.test(value) &&
                        value.length <= 5) ||
                      (uom === "Units" &&
                        /^[0-9]*$/.test(value) &&
                        value.length <= 5)
                    ) {
                      handleInputChange(row.index, "system_quantity", value);
                    }
                  }}
                  onFocus={() => handleInputFocus(row.index, "system_quantity")}
                  onKeyPress={(e) => {
                    const value = e.target.value;
                    if (
                      (uom !== "Units" &&
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        !(
                          e.key === "." &&
                          (value === "" || !value.includes("."))
                        )) ||
                      (uom === "Units" &&
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace")
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
              ) : (
                `${
                  editValues[row.index]?.system_quantity ??
                  row.values.system_quantity?.toFixed(2)
                }`
              )}
            </div>
          );
        },
      },

      ...(!allStores
        ? [
            {
              Header: "",
              disableSortBy: true,
              accessor: "dropdown",
              width: 40,
              Cell: (row) => (
                <div className="flex justify-center">
                  <img
                    src={Edit}
                    style={{
                      cursor: "pointer",
                      height: "0.9rem",
                      width: "0.9rem",
                    }}
                    alt="Edit"
                    className={`mt--2 ${
                      i18n.language == "en" ? "mr-2" : "ml-2"
                    }`}
                    onClick={(e, index) => {
                      e.preventDefault();
                      setindexarray([...indexarray, parseInt(row.row.id)]);
                      handleEditRow(row.row.id);
                    }}
                  />
                </div>
              ),
            },
          ]
        : []),
    ],
    [editRows, editValues, selectedProducts, isShowCostPrice]
  );

  const inputRefs = useRef([]);

  const handleInputChange = (index, field, value) => {
    console.log('new item--->',index,field, value);
    
    if (field === "group_ids") {
      setTempEditValues((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          group_ids: value,
        },
      }));
      return;
    }

    const textFields = ["product_name2"];
    const textFields2 = ["product_shortcut"];
    const textFields3 = ["secondary_barcode"];
    const textFields4 = ["machine_barcode"];

    if (textFields.includes(field) || textFields2.includes(field) || textFields3.includes(field) || textFields4.includes(field)) {
      setTempEditValues((prevValues) => ({
        ...prevValues,
        [index]: {
          ...prevValues[index],
          [field]: value,
        },
      }));
      return;
    }

    const numericValue =
      value === "" || value === null ? 0 : parseFloat(value);

    setTempEditValues((prevValues) => ({
      ...prevValues,
      [index]: {
        ...prevValues[index],
        [field]: numericValue,
      },
    }));
  };

  const handleInputFocus = (index, field) => {
    if (inputRefs.current[index] && inputRefs.current[index][field]) {
      inputRefs.current[index][field].focus();
    }
  };

  const handleSaveAll = () => {
    let sendData = [];
    let hasError = false;

    data.forEach((row, idx) => {
      if (!editRows.has(idx) || hasError) return;

      const salePrice =
        tempEditValues[idx]?.current_price ?? row.current_price;

      const costPrice =
        tempEditValues[idx]?.current_cost_price ?? row.current_cost_price;

      if(costingMethod == "AVCO" && (costPrice == "" || costPrice <= 0)){
        toast.error("Cost Price cannot be zero.");
        hasError = true;
        return;
      }

      if (salePrice < costPrice) {
        toast.error("Sale price cannot be less than cost price.");
        hasError = true;
        return;
      }

      const rawBarcode =
        tempEditValues[idx]?.machine_barcode ?? row.machine_barcode ?? "";
      const machineBarcode = rawBarcode.toString().trim();

      if (
        machineBarcode !== "0" &&
        machineBarcode !== "false" &&
        machineBarcode.length < 7
      ) {
        toast.error("Product Code must be at least 7 digits");
        hasError = true;
        return;
      }

      const discountedPrice =
        row.discounted_price > salePrice
          ? salePrice
          : tempEditValues[idx]?.discounted_price ?? row.discounted_price;

      const rowId = row.quant_id;

      const prevGroupIds =
        row.group_list?.map((g) => g.id) ?? [];

      const currentGroupIds =
        tempEditValues[idx]?.group_ids !== undefined
          ? tempEditValues[idx].group_ids
          : prevGroupIds;

      const removedGroupIds = prevGroupIds.filter(
        (id) => !currentGroupIds.includes(id)
      );

      sendData.push({
        quant_id: row.quant_id,
        new_price: salePrice,
        new_cost_price: costPrice,
        new_quantity:
          tempEditValues[idx]?.system_quantity ?? row.system_quantity,
        group_ids: currentGroupIds,
        remove_group_ids: removedGroupIds,
        machine_barcode:
          tempEditValues[idx]?.machine_barcode === 0
            ? ""
            : tempEditValues[idx]?.machine_barcode ??
              row.machine_barcode ??
              "",

        product_name2:
          tempEditValues[idx]?.product_name2 ?? row.product_name2,

        product_shortcut:
          tempEditValues[idx]?.product_shortcut ?? row.product_shortcut,

        secondary_barcode:
          tempEditValues[idx]?.secondary_barcode ?? (row.secondary_barcode ? row.secondary_barcode : ''),

        discounted_price: discountedPrice,

        egs_code:
          tempEditValues[idx]?.egs_code === 0
            ? ""
            : tempEditValues[idx]?.egs_code ?? row.egs_code ?? "",
      });
    });

    if (hasError) return;
    console.log('sendData==>',sendData);

    setEditRows(new Set());
    setindexarray([]);
    setEditValues(tempEditValues);
    setTempEditValues({});
    setEditPriceClicked(false);
    setAdditionalData(sendData);
  };

  const handleEditRow = (index) => {
    if (checkPermission("/inventory", isGinne)) {
      setEditRows(new Set([...indexarray, parseInt(index)]));
      setEditPriceClicked(true);
    }
  };

  const handleEditCancel = () => {
    setEditRows(new Set());
    setindexarray([]);
    setEditValues({});
    setTempEditValues({});
    setEditPriceClicked(false);
  };

  // --- Generate SVG barcode ---
  const generateBarcodeSVG = (value, options = {}) => {
    const svg = document.createElement("svg");

    JsBarcode(svg, value, {
      format: "CODE128",
      lineColor: "#000",
      height: options.height || 60,
      displayValue: options.displayValue !== undefined ? options.displayValue : true,
      fontSize: options.fontSize || 20,
      margin: 0,
      width: options.width || 1.5,
    });

    return svg.outerHTML;
  };

  // --- Print Labels: 35×24mm (existing, with name + optional price) ---
  const handlePrintLabels35x24 = (isPrice) => {
    const labels = selectedProducts
      .map((item) => {
        const barcodeSVG = generateBarcodeSVG(item.barcode);

        return `
        <div class="label">
          <div class="product-name">${item.name}</div>
          ${barcodeSVG}
          ${
            isPrice
              ? `<div class="price">EGP ${item.price ? item.price : "0"}</div>`
              : ""
          }
        </div>
      `;
      })
      .join("");

    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8" />
      <title>Print Labels 35x24</title>
      <style>
        @page {
          size: 35mm 24mm;
          margin: 0;
        }

        body {
          padding: 0;
          font-family: Arial, sans-serif;
          margin: 0 auto;
        }

        .label {
          width: 35mm;
          height: 24mm;
          margin: 0 auto;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          text-align: center;
          padding: 1mm 1mm;
        }

        .label svg {
          width: 33mm;
          height: 10mm;
          display: block;
        }

        .product-name {
          font-size: 2.7mm;
          max-height: 9mm;
          overflow: hidden;
          margin-top: auto;
          margin-bottom: 3px;
        }

        .price {
          font-size: 3mm;
          margin-top: 1px;
        }
      </style>
    </head>
    <body>
      ${labels}
    </body>
    </html>
  `;

    const printWindow = window.open("", "_blank");
    printWindow.document.write(htmlContent);
    printWindow.document.close();

    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 300);
  };

  // --- Print Labels: 35×24mm two-barcode layout ---
  // Same page size as the existing label (35×24mm).
  // Two products' barcodes printed one after another on a single page.
  // No product name, no price.
const handlePrintLabels35x12 = (isPrice) => {
  const pairs = [];
  for (let i = 0; i < selectedProducts.length; i += 2) {
    pairs.push([selectedProducts[i], selectedProducts[i + 1] || null]);
  }

const renderSlot = (item) => {
  if (!item) return "";
  const svg = item.barcode
    ? generateBarcodeSVG(item.barcode, { height: 28, displayValue: false, width: 1.2 })
    : `<div style="color:#999;font-size:2mm;text-align:center;">No Barcode</div>`;
  return `
    <table cellpadding="0" cellspacing="0" style="width:35mm;border-collapse:collapse;">
      <tr>
        <td style="width:2mm;"></td>
        <td style="width:31mm;text-align:center;vertical-align:middle;">
          <div class="barcode-wrap">${svg}</div>
          <div class="info-row">
            <span class="barcode-num">${item.barcode ?? ""}</span>
            ${isPrice ? `<span class="price">EGP ${item.price ?? "0"}</span>` : ""}
          </div>
        </td>
        <td style="width:2mm;"></td>
      </tr>
    </table>
  `;
};

  const pairHTML = pairs.map(([top, bottom]) => `
    <table class="page" cellpadding="0" cellspacing="0">
      <tr>
        <td class="slot">${renderSlot(top)}</td>
      </tr>
      <tr>
        <td class="divider-row"><div class="divider"></div></td>
      </tr>
      <tr>
        <td class="slot">${renderSlot(bottom)}</td>
      </tr>
    </table>
  `).join("");

  const htmlContent = `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Print Labels</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }

    @page {
      size: 35mm 24mm;
      margin: 0;
    }

    html, body {
      width: 35mm;
      margin: 0;
      padding: 0;
      font-family: Arial, sans-serif;
    }

    .page {
      width: 35mm;
      height: 24mm;
      page-break-after: always;
      border-collapse: collapse;
      table-layout: fixed;
      overflow: hidden;
    }

    .slot {
      width: 35mm;
      height: 11mm;
      text-align: center;
      vertical-align: middle;
      padding: 0.3mm 0;
      overflow: hidden;
    }

    /* Fixed barcode container — always same height regardless of barcode length */
    .barcode-wrap {
      width: 31mm;
      height: 7mm;
      overflow: hidden;
      margin: 0 auto;
      flex-shrink: 0;
    }

    .barcode-wrap svg {
      display: block !important;
       max-width: 33mm !important;
      height: 7mm !important;
      margin: 0 auto !important;
    }

    /* Number on left, price on right — same line */
    .info-row {
      width: 33mm;
      margin: 0.4mm auto 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      line-height: 1;
    }

    .barcode-num {
      font-size: 2mm;
      color: #333;
      text-align: left;
    }

    .price {
    font-size: 2mm;
      color: #333;
      text-align: right;
    }

    .divider-row {
      height: 2mm;
      padding: 0;
      vertical-align: middle;
    }

    .divider {
      width: 30mm;
      height: 0.3mm;
      background: #ccc;
      margin: 0 auto;
    }
  </style>
</head>
<body>
  ${pairHTML}
</body>
</html>`;

  const printWindow = window.open("", "_blank");
  printWindow.document.write(htmlContent);
  printWindow.document.close();
  setTimeout(() => { printWindow.print(); printWindow.close(); }, 300);
};

  // Unified handler called from the modal buttons
  const handlePrintLabels = (isPrice) => {
    if (labelSize === "35x12") {
      // 35×12mm ignores the price/no-price choice — barcode only
      handlePrintLabels35x12(isPrice);
    } else {
      handlePrintLabels35x24(isPrice);
    }
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
    state: { pageSize },
    selectedFlatRows,
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 10 },
    },
    useSortBy,
    usePagination
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <Modal
        visible={isImageModalVisible}
        onCancel={() => setIsImageModalVisible(false)}
        footer={null}
      >
        <img src={currentImageUrl} alt="Product" style={{ width: "100%" }} />
      </Modal>

      {/* ── Print Label Modal ── */}
      {showPriceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-8 w-[520px] shadow-2xl text-center relative">
            <button
              className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl"
              onClick={() => setShowPriceModal(false)}
            >
              ×
            </button>

            {/* Label size sample image */}
            <div className="flex justify-center mb-4">
              {labelSize === "35x24" ? 
                <img
                src={labelSample}
                alt="Label size example"
                className="w-72 rounded-lg border"
              />
               :
                <img
                src={labelSample2}
                alt="Label size example"
                className="w-72 rounded-lg border"
              />
              }
            
            </div>

            {/* ── NEW: Label size selector ── */}
            <div className="mb-5">
              <p className="text-sm text-gray-500 mb-2 font-medium">
                {t("Select Label Size")}
              </p>
              <div className="flex justify-center gap-4">
                {/* 35×24 option */}
                <button
                  onClick={() => setLabelSize("35x24")}
                  className={`flex flex-col items-center px-5 py-3 rounded-xl border-2 transition-all ${
                    labelSize === "35x24"
                      ? "border-primaryBlue bg-blue-50 text-primaryBlue"
                      : "border-gray-200 text-gray-500 hover:border-gray-400"
                  }`}
                >
                  {/* Visual icon: taller rectangle */}
                  <div
                    className={`mb-1 rounded border-2 ${
                      labelSize === "35x24" ? "border-primaryBlue" : "border-gray-400"
                    }`}
                    style={{ width: 40, height: 27 }}
                  />
                  <span className="text-xs font-semibold">35 × 24 mm</span>
                  <span className="text-[10px] text-gray-400 mt-0.5">
                    {t("Name + Barcode")}
                  </span>
                </button>

                {/* 35×12 option */}
                <button
                  onClick={() => setLabelSize("35x12")}
                  className={`flex flex-col items-center px-5 py-3 rounded-xl border-2 transition-all ${
                    labelSize === "35x12"
                      ? "border-primaryBlue bg-blue-50 text-primaryBlue"
                      : "border-gray-200 text-gray-500 hover:border-gray-400"
                  }`}
                >
                  {/* Visual icon: single narrow landscape rectangle */}
                  <div
                    className={`rounded border-2 mb-1 ${
                      labelSize === "35x12" ? "border-primaryBlue" : "border-gray-400"
                    }`}
                    style={{ width: 40, height: 13 }}
                  />
                  <span className="text-xs font-semibold">35 × 12 mm</span>
                  <span className="text-[10px] text-gray-400 mt-0.5">
                    {t("Barcode Only")}
                  </span>
                </button>
              </div>
            </div>

            {/* ── Conditional bottom section ── */}
            {labelSize === "35x24" ? (
              // Existing 35×24 flow: ask about price
              <>
                <p className="text-base text-gray-700 mb-4">
                  {t("Your labels are sized 35mm × 24mm as shown above.")}
                </p>
                <h2 className="text-xl font-semibold mb-6">
                  {t("Do you want to print product price also?")}
                </h2>
                <div className="flex justify-between mt-4">
                  <button
                    className="px-6 py-3 bg-gray-300 rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowPriceModal(false);
                      handlePrintLabels(true);
                    }}
                  >
                    {t("No")}
                  </button>

                  <button
                    className="px-6 py-3 bg-primaryBlue text-white rounded-lg w-32 text-lg font-medium"
                    onClick={() => {
                      setShowPriceModal(false);
                      handlePrintLabels(true); // With price
                    }}
                  >
                    {t("Yes")}
                  </button>
                </div>
              </>
            ) : (
              // 35×12 flow: no price question, just print
              <>
               <p className="text-base text-gray-700 mb-4">
      {t("Two barcodes printed per 35×24mm label.")}
    </p>
    <h2 className="text-xl font-semibold mb-6">
      {t("Do you want to print product price also?")}
    </h2>
    <div className="flex justify-between mt-4">
      <button
        className="px-6 py-3 bg-gray-300 rounded-lg w-32 text-lg font-medium"
        onClick={() => {
          setShowPriceModal(false);
          handlePrintLabels(true); // Without price
        }}
      >
        {t("No")}
      </button>
      <button
        className="px-6 py-3 bg-primaryBlue text-white rounded-lg w-32 text-lg font-medium"
        onClick={() => {
          setShowPriceModal(false);
          handlePrintLabels(true); // With price
        }}
      >
        {t("Yes")}
      </button>
    </div>
              </>
            )}
          </div>
        </div>
      )}

      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {selectedProducts.length > 0 && (
          <div className="flex justify-end mb-4">
            <button
              onClick={() => setShowPriceModal(true)}
              className="w-32 h-8 bg-[#7EC242] text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
            >
              {t("Print Labels")}
            </button>
          </div>
        )}

        {/* Save All button */}
        {editPriceClicked && (
          <div className="flex justify-end mb-5">
            {editRows.size === 1 ? (
              <button
                onClick={handleSaveAll}
                className="w-28 h-8 mt-1 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
              >
                <span>{t("save")}</span>
              </button>
            ) : (
              <button
                onClick={handleSaveAll}
                className="w-28 h-8 mt-1 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center me-5"
              >
                <span>{t("save_all")}</span>
              </button>
            )}
            <button
              onClick={handleEditCancel}
              className="w-28 h-8 mt-1 bg-white border border-primaryBlue text-primaryBlue text-sm font-semibold rounded-lg flex items-center justify-center me-5"
            >
              <span>{t("Cancel")}</span>
            </button>
          </div>
        )}

        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ms-4">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            <div className="overflow-x-auto scrollbar-thin pe-4">
              <table
                {...getTableProps()}
                className="min-w-max w-full border-collapse rounded-lg overflow-hidden"
              >
                <thead className="bg-[#78CFEC66]">
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <th
                          {...column.getHeaderProps(column.getSortByToggleProps())}
                          className="py-3 px-2 text-sm text-left align-top whitespace-normal break-words leading-snug"
                        >
                          <div className="flex flex-row items-center ms-2 text-sm leading-tight ">
                            {column.render("Header")}
                            {column.canSort && (
                              <span className="ms-1">
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <img
                                      src={Vectorsorting}
                                      style={{ minHeight: 10, minWidth: 10 }}
                                      alt="vector"
                                    />
                                  ) : (
                                    <img
                                      className="rotate-180"
                                      src={Vectorsorting}
                                      alt="vector"
                                    />
                                  )
                                ) : (
                                  <img
                                    src={Vectorsorting}
                                    alt="sortable"
                                    style={{ minHeight: 10, minWidth: 10, opacity: 0.3 }}
                                  />
                                )}
                              </span>
                            )}
                          </div>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()} className="bg-[#F7F9FD]">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        className="border-b border-gray-300 hover:bg-white"
                      >
                        {row.cells.map((cell) => (
                          <td
                            {...cell.getCellProps()}
                            className="p-2 text-sm text-left align-top whitespace-normal break-words"
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex !== 1}
                canNextPage={data?.length === pageSize}
                gotoPage={(page) => nextPage(page)}
                previousPage={() => setpageIndex(pageIndex - 1)}
                nextPage={() => setpageIndex(pageIndex + 1)}
                pageSize={pageSize}
                setPageSize={(pageSize) => setPageSize(pageSize)}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InventoryTableComponent;